import type { ReceiptTemplate } from '../schema';

export const samsungTemplate: ReceiptTemplate = {
  id: 'samsung',
  name: 'Samsung Receipt',
  brand: 'SAMSUNG',
  description: 'Samsung electronics store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'samsung-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/samsung.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'SAMSUNG EXPERIENCE STORE',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'samsung-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'SM-847291034' },
          { id: 'assoc', label: 'Specialist:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'samsung-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'GALAXY S24 ULTRA', quantity: '1', price: '1299.99', sku: 'SM-S928B' },
          { id: '2', name: 'GALAXY BUDS3 PRO', quantity: '1', price: '249.99', sku: 'SM-R630' },
          { id: '3', name: 'PROTECTIVE CASE', quantity: '1', price: '49.99', sku: 'EF-PS928' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'samsung-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1599.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '132.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1731.97', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'samsung-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'SAMSUNG PAY ****4144',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'samsung-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'SAMSUNG CARE+ INCLUDED\n\nReturns within 15 days\nwww.samsung.com\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

